/**
 * NLB-GW
 *
 * Contact: service@rheinenergie.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OptInPostData { 
    /**
     * indicates if customer wants to receive advertisements
     */
    optInFlag?: boolean;
}

